// extracted by css-extract-rspack-plugin
export default {"authorAvatar":"CommitAuthors-module__authorAvatar__aKgDO","committerAvatar":"CommitAuthors-module__committerAvatar__acvIv"};